import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {inject} from '@angular/core';
import {VatRateClient, VatRateDto} from '../../core/services/service-clients';
import {firstValueFrom} from 'rxjs';
import {VatRateState} from './models/vat-rate.model';

const initialState: VatRateState = {
  vatRates: [],
  loading: false,
};

export const vatRateStore = signalStore(
  withState<VatRateState>(initialState),

  withMethods(store => {
    const vatRateClient = inject(VatRateClient);

    return {
      // Load VAT rates
      async loadVatRates() {
        patchState(store, {loading: true});
        try {
          const vatRates = await firstValueFrom(vatRateClient.get());
          patchState(store, {vatRates, loading: false});
          return true;
        } catch {
          patchState(store, {loading: false});
          return false;
        }
      },

      // Add VAT rate
      async addVatRate(vatRate: VatRateDto) {
        patchState(store, {loading: true});
        try {
          const vatRates = await firstValueFrom(vatRateClient.post(vatRate));
          patchState(store, {vatRates, loading: false});
          return true;
        } catch {
          patchState(store, {loading: false});
          return false;
        }
      },

      // Update VAT rate
      async updateVatRate(vatRate: VatRateDto) {
        patchState(store, {loading: true});
        try {
          const vatRates = await firstValueFrom(vatRateClient.put(vatRate));
          patchState(store, {vatRates, loading: false});
          return true;
        } catch {
          patchState(store, {loading: false});
          return false;
        }
      },

      // Delete VAT rate
      async deleteVatRate(vatRateId: number) {
        patchState(store, {loading: true});
        try {
          const vatRates = await firstValueFrom(vatRateClient.delete(vatRateId));
          patchState(store, {vatRates, loading: false});
          return true;
        } catch {
          patchState(store, {loading: false});
          return false;
        }
      }
    };
  })
);
